"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { SVGIcon } from "../SVGIcon";
import { createSVGIcon } from "../util";

/**
 * @deprecated use Lock from `@faire/slate/icons/Lock`
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const LockSquare = createSVGIcon(
  <>
    <path fill="currentColor" d="M0 6H12V14H0z" />
    <rect x="2.5" y=".5" width="7" height="13" rx="3.5" stroke="currentColor" />
  </>,
  "Lock",
  { viewBox: "0 0 12 14", fill: "none", className: legacyIconCls() } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);

/**
 * @deprecated use Lock from @faire/slate/icons/Lock
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const LockCircle = createSVGIcon(
  <g fillRule="nonzero" fill="currentColor">
    <path d="M7 18.97c-3.805 0-6.89-3.14-6.89-7.012C.11 8.085 3.196 4.946 7 4.946c3.805 0 6.89 3.14 6.89 7.012-.004 3.871-3.087 7.009-6.89 7.012M7 6.178c-3.136 0-5.679 2.588-5.679 5.78s2.543 5.78 5.679 5.78 5.679-2.588 5.679-5.78c-.003-3.19-2.544-5.777-5.679-5.78" />
    <ellipse cx="7" cy="11.958" rx="1.301" ry="1.324" />
    <path d="M6.393 11.958h1.21v3.687h-1.21zm4.609-5.353H9.788v-3.34c0-1.104-1.26-2.006-2.806-2.006-1.545 0-2.802.89-2.802 2.007v3.34H2.97v-3.34c0-1.782 1.799-3.24 4.015-3.24 2.217 0 4.017 1.458 4.017 3.24v3.34z" />
  </g>,
  "Lock",
  { viewBox: "0 0 22 22", className: legacyIconCls() } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);

/**
 * @deprecated use Lock from `@faire/slate/icons/Lock`
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const LockRoundBottom = createSVGIcon(
  <>
    <path
      d="M9.652 18.526H5.348C2.944 18.526 1 16.537 1 14.078V6.7h13v7.378c0 2.453-1.944 4.448-4.348 4.448Z"
      stroke="currentcolor"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M3.273 6.656V5.32C3.273 2.931 5.167 1 7.496 1c2.33 0 4.224 1.938 4.224 4.321v1.335"
      stroke="currentcolor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M7.503 11.244v4.467" stroke="currentcolor" strokeMiterlimit="10" />
    <path
      d="M7.503 11.797c.566 0 1.025-.47 1.025-1.05 0-.578-.459-1.048-1.025-1.048s-1.024.47-1.024 1.049.458 1.049 1.024 1.049"
      fill="currentcolor"
    />
  </>,
  "Lock",
  { viewBox: "0 0 15 20", fill: "none", className: legacyIconCls() } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);

/**
 * @deprecated use Lock from `@faire/slate/icons/Lock`
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const LockFlatTop = createSVGIcon(
  <path
    d="M16 1.755A1.714 1.714 0 0 0 14.286.041H1.714A1.714 1.714 0 0 0 0 1.755v3.338a11.59 11.59 0 0 0 7.384 10.752c.396.152.836.152 1.232 0A11.59 11.59 0 0 0 16 5.093zM9.286 7.982a.29.29 0 0 0-.143.247v2.098a1.143 1.143 0 0 1-2.286 0V8.229a.29.29 0 0 0-.143-.248 2.571 2.571 0 1 1 2.572 0z"
    fill="currentcolor"
    clipPath="url(#prefix__clip0)"
  />,
  "Lock",
  { viewBox: "0 0 24 24", fill: "none", className: legacyIconCls() } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);

/**
 * @deprecated use Lock from `@faire/slate/icons/Lock`
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const LockRoundedSquare = createSVGIcon(
  <>
    <path
      d="M1 11.667h18.666V25H1z"
      stroke="#AAA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8.333 18.334a2 2 0 1 0 4 0 2 2 0 0 0-4 0" fill="#AAA" />
    <path
      d="M3.667 11.667v-4a6.667 6.667 0 1 1 13.333 0v4"
      stroke="#AAA"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Lock",
  { viewBox: "0 0 21 26", fill: "none", className: legacyIconCls() } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);

type LockType = "square" | "circle" | "roundBottom" | "flat" | "roundedSquare";

/**
 * @deprecated
 * @trackcomponent
 */
export const Lock = React.memo(
  ({
    lockType,
    ref,
    ...props
  }: SVGIcon.IProps & {
    lockType: LockType;
  } & React.RefAttributes<SVGElement>) => {
    let SelectedLock = LockSquare;
    switch (lockType) {
      case "circle":
        SelectedLock = LockCircle;
        break;
      case "roundBottom":
        SelectedLock = LockRoundBottom;
        break;
      case "flat":
        SelectedLock = LockFlatTop;
        break;
      case "roundedSquare":
        SelectedLock = LockRoundedSquare;
        break;
      case "square":
      default:
        break;
    }
    return <SelectedLock ref={ref} {...props} />;
  }
);
